import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";

const staffSection = "/staff/";

export const staffListPath = staffSection;
export enum StaffListUrlFiltersEnum {
  status = "status",
  query = "query",
  mfaStatus = "mfaStatus"
}
export enum StaffListUrlFiltersWithMultipleValues {
  groups = "groups"
}

export type StaffListUrlFilters = Filters<StaffListUrlFiltersEnum> &
  FiltersWithMultipleValues<StaffListUrlFiltersWithMultipleValues>;
export type StaffListUrlDialog = "add" | "remove" | TabActionDialog;
export enum StaffListUrlSortField {
  name = "name",
  email = "email"
}
export type StaffListUrlSort = Sort<StaffListUrlSortField>;
export type StaffListUrlQueryParams = ActiveTab &
  BulkAction &
  Dialog<StaffListUrlDialog> &
  Pagination &
  StaffListUrlFilters &
  StaffListUrlSort;
export const staffListUrl = (params?: StaffListUrlQueryParams) =>
  staffListPath + "?" + stringifyQs(params);

export const staffMemberAddPath = urlJoin(staffSection, "/add");

export const userBusinessDetailsPath = "/business-details/";

export const staffMemberDetailsPath = (id: string) => urlJoin(staffSection, id);
export type StaffMemberDetailsUrlDialog =
  | "change-password"
  | "remove"
  | "remove-avatar"
  | "change-other-password";
export type StaffMemberDetailsUrlQueryParams = Dialog<
  StaffMemberDetailsUrlDialog
>;

export const staffMemberDetailsUrl = (
  id: string,
  params?: StaffMemberDetailsUrlQueryParams
) => staffMemberDetailsPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
